module.exports = __webpack_public_path__ + "media/components/maps/apps/icons/Neutral-ce5e316ebf6063a5f1a76a5ce9ed790c.png";